import { render, staticRenderFns } from "./ViewsModal.vue?vue&type=template&id=be4bcede&scoped=true"
import script from "./ViewsModal.vue?vue&type=script&lang=js"
export * from "./ViewsModal.vue?vue&type=script&lang=js"
import style0 from "./ViewsModal.vue?vue&type=style&index=0&id=be4bcede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4bcede",
  null
  
)

export default component.exports